module.exports = __webpack_public_path__ + "img/dr.bob.50548722.jpg";